// eslint-disable-next-line no-unused-vars

export const ADD_POST_APPROVAL_EVENT = '@types/add-post-approval-event';
export const REMOVE_POST_APPROVAL_EVENT = '@types/remove-post-approval-event';
export const SET_INITIAL_POST_APPROVAL_EVENTS = '@types/set-initial-post-approval-events';

/**
 * Action used to add to the list of post-approval
 * events that require a response from an agent/motorclub;
 * there is no timeout but these are usually time-sensitive.
 * When a event is added via WebPubSub we send in the new Post Approval
 * event record (1 record) and add it to the array state
 * @param {digitalDispatchTypes.PostApprovalEvent} newPostApprovalEvent
 * @returns {function}
 */
export function addPostApprovalEventNotification(newPostApprovalEvent) {
  return (dispatch) => {
    dispatch({
      type: ADD_POST_APPROVAL_EVENT,
      payload: {
        newPostApprovalEvent
      }
    });
  };
}

/**
 * Action used to set the initial batch of post approval
 * events that need to be responded to
 * @param {Array<digitalDispatchTypes.PostApprovalEvent>} initialPostApprovalEvents
 * @returns {function}
 */
export function addInitialPostApprovalEvents(initialPostApprovalEvents) {
  return (dispatch) => {
    dispatch({
      type: SET_INITIAL_POST_APPROVAL_EVENTS,
      payload: {
        initialPostApprovalEvents
      }
    });
  };
}

/**
 * Action used to remove records from the list of post-approval
 * events that require a response from an agent/motorclub.
 * When a event is removed (i.e. motorclub or agent responded)
 * we send in the Id (PK) of Post Approval event record
 * (1 record) and remove that record from the reducer state to
 * indicate it doesn't need any further interaction
 * @param {number} answeredPostApprovalEventId
 * @returns {function}
 */
export function removePostApprovalEventNotification(answeredPostApprovalEventId) {
  return (dispatch) => {
    dispatch({
      type: REMOVE_POST_APPROVAL_EVENT,
      payload: {
        answeredPostApprovalEventId
      }
    });
  };
}
